import { render } from "./ReportPlantationView.vue?vue&type=template&id=d888a968&scoped=true"
import script from "./ReportPlantationView.vue?vue&type=script&lang=js"
export * from "./ReportPlantationView.vue?vue&type=script&lang=js"

import "./ReportPlantationView.vue?vue&type=style&index=0&id=d888a968&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d888a968"]])

export default __exports__